import React from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import DateTimePicker from "react-datetime-picker";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import { datetimeToString, dateToString } from "./services/UtilityService";
import { fetchReport } from "./services/DataService";
import "./style/home.scss";
import "./style/program.scss";

class Report extends React.Component {
  constructor(props) {
    super(props);
    let currentDate = new Date();
    this.state = {
      loading: true,
      start: new Date(currentDate.setMonth(currentDate.getMonth() - 1)),
      end: new Date(),
      playlist: null,
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    this.setState({ validated: true });
    var isValid = form.checkValidity();
    if (isValid) {
      var start_date = datetimeToString(this.state.start).slice(0, 10);
      var end_date = datetimeToString(this.state.end).slice(0, 10);
      fetchReport(start_date, end_date).then((data) =>
        this.setState({ playlist: data })
      );
    }
  };

  render() {
    let sortCarets = (order, column) => {
      if (!order)
        return (
          <span className="sort-glyph-group">
            <span className="sort-glyph-both glyphicon glyphicon-triangle-top"></span>
            <span className="sort-glyph-both glyphicon glyphicon-triangle-bottom"></span>
          </span>
        );
      else if (order === "asc")
        return (
          <span className="sort-glyph glyphicon glyphicon-triangle-top"></span>
        );
      else if (order === "desc")
        return (
          <span className="sort-glyph glyphicon glyphicon-triangle-bottom"></span>
        );
      return null;
    };

    const { ExportCSVButton } = CSVExport;

    const pageButtonRenderer = ({ page, active, onPageChange }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onPageChange(page);
      };
      const activeStyle = {};
      if (active) {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "red";
      } else {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      }
      if (typeof page === "string") {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      }
      return (
        <a
          href="/#"
          className="page-link"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </a>
      );
    };

    let inputForm;
    if (!this.state.playlist) {
      inputForm = (
        <div className="report-form">
          <Form
            className="form"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleSubmit}
            style={{ maxWidth: "50%" }}
          >
            <Form.Group as={Row}>
              <Form.Label
                column
                sm="3"
                className="d-flex align-items-center flex-row-reverse  mb-2"
              >
                Start
              </Form.Label>
              <Col sm="8">
                <DateTimePicker
                  showTimeSelect="false"
                  className="form-control"
                  value={this.state.start}
                  onChange={(dt) => {
                    this.setState({ start: dt });
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label
                column
                sm="3"
                className="d-flex align-items-center flex-row-reverse  mb-2"
              >
                End
              </Form.Label>
              <Col sm="8">
                <DateTimePicker
                  showTimeSelect="false"
                  className="form-control"
                  value={this.state.end}
                  onChange={(dt) => {
                    this.setState({ end: dt });
                  }}
                />
              </Col>
            </Form.Group>
            <div className="d-flex justify-content-center">
              <div style={{ width: "95px" }}></div>
              <Button variant="primary" type="submit" className="btn-submit">
                Submit
              </Button>
            </div>
          </Form>
        </div>
      );
    }

    let reportTable;

    if (this.state.playlist) {
      const upperCase = (cell) => {
        return cell.toUpperCase();
      };
      console.log(this.state.playlist);
      reportTable = (
        <ToolkitProvider
          keyField="id"
          responsive="sm"
          size="sm"
          data={this.state.playlist}
          rowStyle={{ fontSize: 20, maxWidth: "10%" }}
          exportCSV={{
            fileName: `kugs-playlist-report-${dateToString(
              this.state.start
            )}-to-${dateToString(this.state.end)}.csv`,
          }}
          columns={[
            {
              dataField: "play_time",
              text: "Play time",
              sort: true,
              sortCaret: sortCarets,
              formatter: (cell) => {
                return cell.slice(0, 10);
              },
            },
            {
              dataField: "artist",
              text: "Artist",
              sort: true,
              sortCaret: sortCarets,
              csvFormatter: upperCase,
            },
            {
              dataField: "title",
              text: "Title",
              sort: true,
              sortCaret: sortCarets,
              csvFormatter: upperCase,
            },
            {
              dataField: "album",
              text: "Album",
              sort: true,
              sortCaret: sortCarets,
              csvFormatter: upperCase,
            },
            {
              dataField: "label",
              text: "Label",
              sort: true,
              sortCaret: sortCarets,
              csvFormatter: upperCase,
            },
          ]}
        >
          {(props) => (
            <div>
              <div className="print-btn pt-5">
                <ExportCSVButton {...props.csvProps} style={{ color: "white" }}>
                  Export CSV
                </ExportCSVButton>
              </div>
              <hr />
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory({ pageButtonRenderer })}
              />
            </div>
          )}
        </ToolkitProvider>
      );
    }
    return (
      <div>
        <div className="form-title">Report</div>
        {inputForm}
        {reportTable}
      </div>
    );
  }
}

export default Report;
